import React, { Component } from "react";
import { instanceOf } from "prop-types";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { withCookies, Cookies } from "react-cookie";
import shortid from "shortid";
import selectn from "selectn";

import ConditionalNavigation from "../Library/ConditionalNavigation";
import NotFound from "components/Library/NotFound";
import ScrollToTop from "../Library/ScrollToTop";
import CookieWarning from "components/Library/CookieWarning";
import UniversalRouter from "../../utils/UniversalRouter";
import ErrorPageWrapper from "components/Library/ErrorPageWrapper";
import { setCookieParams } from "utils/cookies";

import { routes } from "routes";
import { setPageTitleInDataLayer, setUserInDataLayer } from "utils/analytics";

import styles from "./App.css";
import ogImg from "assets/img/social-default.png";
import { HeaderContext } from "../../config/contexts";
import { COOKIES, HEADER_LEVELS } from "../../config/constants";

class App extends Component {
  constructor(props) {
    super(props);
    if (typeof global !== "undefined" && this.props.cookies) {
      global.cookies = this.props.cookies;
    }

    this.state = {
      isError: false,
    };
  }

  componentDidMount() {
    setPageTitleInDataLayer();
  }

  // the Preview component is the only place the redux store storiesStream is used
  componentWillReceiveProps(nextProps) {
    // If we are trying to log in but didn't succeed or if user logs out, create anon user ga token
    if (
      (this.props.loggedIn === undefined || this.props.loggedIn) &&
      nextProps.loggedIn === false
    ) {
      this.setAnonymousUser();
    }

    if (!this.props.storiesStream.isError && nextProps.storiesStream.isError) {
      const payload = nextProps.storiesStream.error;
      if (
        payload &&
        payload.handleError &&
        selectn("error.response.status", payload) === 404 &&
        !nextProps.storiesStream.results.length
      ) {
        this.setState({ isError: true });
      }
    } else if (
      this.state.isError &&
      this.props.storiesStream.isError &&
      !nextProps.storiesStream.isError
    ) {
      this.setState({ isError: false });
    }
  }

  setAnonymousUser = () => {
    const { cookies } = this.props;
    let anonUser = cookies.get(COOKIES.ANON_USER);
    if (!anonUser) {
      anonUser = shortid.generate();
      cookies.set(COOKIES.ANON_USER, anonUser, setCookieParams());
    }
    setUserInDataLayer(anonUser, false);
  };

  render() {
    return (
      <HeaderContext.Provider value={HEADER_LEVELS.STREAM_DEFAULT}>
        <>
          <Helmet>
            {/* Default meta tags. These get overwritten by other <Helmet> blocks in e.g. articles, etc. */}
            <title>Axios</title>
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://www.axios.com/" />
            <meta property="og:site_name" content="Axios" />
            <meta property="og:image" content={ogImg} />
            <meta
              name="description"
              content="Smart, efficient news worthy of your time, attention, and trust"
            />
            <meta
              property="og:description"
              content="Smart, efficient news worthy of your time, attention, and trust"
            />
            <meta property="fb:app_id" content="650172611997232" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@axios" />
          </Helmet>
          <UniversalRouter
            context={this.props.staticContext}
            path={this.props.path}
          >
            <ScrollToTop>
              <div>
                <CookieWarning />
                <ConditionalNavigation />
                <div className={styles.root}>
                  <ErrorPageWrapper>
                    <Switch>
                      {this.state.isError && (
                        <Route
                          render={({ staticContext }) => {
                            if (staticContext) staticContext.status = 404;
                            return <NotFound />;
                          }}
                        />
                      )}
                      {routes.map(route => (
                        <Route {...route} key={route.path} />
                      ))}
                    </Switch>
                  </ErrorPageWrapper>
                </div>
              </div>
            </ScrollToTop>
          </UniversalRouter>
        </>
      </HeaderContext.Provider>
    );
  }
}

App.propTypes = {
  cookies: instanceOf(Cookies).isRequired,
};

const mapStateToProps = state => {
  return {
    storiesStream: state.storiesStream,
  };
};

const AppWithRedux = connect(mapStateToProps)(App);
export default withCookies(AppWithRedux);
